import { h } from 'preact'
import { Row } from '@voicemachine/preact-ui'

export default ({ children }) => (
  <Row justifyContent="center" height="100%" textTransform="uppercase" color="#999" fontSize="12px">
    {children}
  </Row>
)
